<template>
  <div id="welcome">
    <div class="search_cotent">
      <el-card>
        <!-- <div class="header_title" style="margin-bottom: 10px">
          <span>
            <i>
              <img
                style="width: 100%; height: 100%"
                src="@/assets/tag.png"
                alt=""
              />
            </i>
            {{ $t("message.title.searchResult") }}
            <i>
              <img
                style="width: 100%; height: 100%"
                src="@/assets/titleicon.png"
                alt=""
              />
            </i>
          </span>
        </div> -->
        <span style="margin: 0 0 6px 0; color: #999">
          <!-- for "<span style="color: #4b91ff">{{ search_data }}</span
          >"  -->
          {{ $t("message.title.totalResults") + totalRecords + $t("message.title.searchUnit") }}
        </span>
        <span style="margin: 0 0 6px 0; color: #999" v-if="this.missingRows > 0">{{ "," + $t("message.title.missingRows")
          }}</span>
        <!-- 浏览器/更多 按钮模块 -->
        <!-- <div
          @mouseover="webview_img = webview_img2"
          @mouseout="webview_img = webview_img1"
          class="btn btn6"
        > -->
        <!-- <i><img :src="webview_img" alt="" /></i>
          浏览器
        </div>
        icon-liulanqi -->
        <!-- <el-button class="btn btn6"
          ><i class="icon icon-liulanqi"></i> 浏览器</el-button
        >
        <el-dropdown placement="bottom" style="margin-left: 10px">
          <el-button size="small" type="primary" plain>
            更多<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>复制</el-dropdown-item>
            <el-dropdown-item disabled>粘贴</el-dropdown-item>
            <el-dropdown-item disabled divided>向下填充</el-dropdown-item>
            <el-dropdown-item disabled>向下填充(所选单元格)</el-dropdown-item>
            <el-dropdown-item disabled divided>向上填充</el-dropdown-item>
            <el-dropdown-item disabled>向上填充(所选单元格)</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
        <div v-if="tableShow">
          <el-table class=showTable border :row-class-name="tableRowClassName" size="small" v-loading="loading" stripe
            :data="rols_text" style="width: 100%; margin-top: 10px" max-height="620" row-key="id" v-show="tableShow"
            @row-click="rowClick">
            <template v-for="(col, index) in cols">
              <el-table-column :prop="col.prop" :label="col.label" :key="index" sortable>
              </el-table-column>
            </template>
          </el-table>
          <el-pagination small class="pagination" background @size-change="handleSizeChange"
            @current-change="handleCurrentChange" :page-sizes="pageSizes"
            layout="total, sizes, prev, pager, next, jumper" :total="totalRecords">
          </el-pagination>
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
import SearchQuery from "./searchItem/search.vue";
export default {
  name: "Show",
  data() {
    return {
      tableUrl: '',
      table1Url: '/pmdm/dashboard/queryChangeChartsDetail',
      table2Url: '/pmdm/dashboard/queryEcoChangeChartsDetail',
      table3Url: '/pmdm/dashboard/queryChangeBubbleDetail',

      searchView: false,

      checked: false,
      loading: false,
      tableShow: false,

      pageSizes: [500, 1000, 1500, 2000],
      pageSize: 500,
      currentPage: 1,
      totalRecords: '',
      missingRows: 0,

      cols: [],
      rols_text: [],
      rols: [],
      search_data: "",
      get_data: [],
      selectGroup: [],
      select_value: "",
      options: [
        {
          value: "101",
          url: "/item",
        },
        {
          value: "104",
          url: "/changePage",
        },
        {
          value: "105",
          url: "/ManuFactPage",
        },
        {
          value: "106",
          url: "/ManuFactPartPage",
        },
        {
          value: "901",
          url: "/UserItem",
        },
        {
          value: "902",
          url: "/UserGroupItem",
        },
        {
          value: "301",
          url: "/project",
        },
      ],
    };
  },
  components: {
    SearchQuery,
  },
  mounted() { },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val
      this.searchSimple()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;

      this.searchSimple()
      // const { data: res } = await this.$http.get(loadTableUrl);
    },
    baseIdChange() {
      this.currentPage = 1;
    },
    getSearch(res) {
      this.showTable(res);
    },
    toAdvancedSearch() {
      let t = {
        title: this.$t('message.title.advancedSearch'),
        name: this.$t('message.title.advancedSearch'),
        path: "/advancedSearch",
        content: "/advancedSearch",
      };
      if (!this.isExistingTab(t.name)) {
        this.$store.commit("setShowingTabsInHome", t);
      }
      this.$store.commit("setActivedTabInHome", t.name);
      this.$router.push(t.path);
    },
    tableRowClassName({ row, rowIndex }) {
      row.row_index = rowIndex;
    },

    rowClick(row, column, event) {
      var num = row.row_index;
      var ids = this.rols[num];
      Object.assign(row, ids);

      const { objId: id, objClass: classId, objSubClass: subClassId, '0': title } = row
      const obj = { id, classId, subClassId, title }
      this.getLink(obj)
    },
    // getSearchSelect() {
    //   this.$http
    //     .get("/pmdm/admin/cls/getBaseClses")
    //     .then((res) => {
    //       let baseClass = res.data.object.baseClses;
    //       this.selectGroup = baseClass.map((i) => {
    //         return { label: i.name, value: i.id };
    //       });
    //       // this.select_value = this.selectGroup[0].value;
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //     });
    // },

    getSearchVal() {
      this.search_value = this.$store.state.changeChartsDetail;
      //this.search_text = this.search_value.val;
      if (this.search_value.tableId == 1) {
        this.tableUrl = this.table1Url;
      } else if (this.search_value.tableId == 2) {
        this.tableUrl = this.table2Url;
      } else if (this.search_value.tableId == 3) {
        this.tableUrl = this.table3Url;
      };
    },
    async getTableInfo() {
      // var obj_get = {
      //   //获取url参数
      //   classId: this.search_value.classId,
      //   dateType: this.search_value.dateType,
      //   size:this.pageSize,
      //   page:1,
      // };
      var obj_get = {};
      console.log(this.search_value);
      if (this.search_value.tableId == 1) {
        obj_get = {
          //获取url参数
          classId: this.search_value.classId,
          dateType: this.search_value.dateType,
          size: this.pageSize,
          page: 1,
        };
      } else if (this.search_value.tableId == 2) {
        obj_get = {
          //获取url参数
          subclassId: this.search_value.subClassId,
          dateType: this.search_value.dateType,
          size: this.pageSize,
          page: 1,
        };
      } else if (this.search_value.tableId == 3) {
        obj_get = {
          //获取url参数
          subclassId: this.search_value.subClassId,
          dateType: this.search_value.dateType,
          size: this.pageSize,
          page: 1,
        };
      };
      console.log(obj_get);
      let loadTableUrl = this.tableUrl + this.params(obj_get);
      const {
        //获取标题测试 第3页
        data: res,
      } = await this.$http.get(loadTableUrl);
      //console.log(res);
      this.showTable(res);
    },
    async searchSimple() {
      let obj_get = {
        //获取url参数
        classId: this.search_value.classId,
        dateType: this.search_value.dateType,
        size: this.pageSize,
        page: this.currentPage,
      };
      // console.log(obj_get); ``;
      //console.log(this.select_value);
      let loadTableUrl = this.tableUrl + this.params(obj_get);;

      const { data: res } = await this.$http.get(loadTableUrl);
      console.log(res);
      this.showTable(res);
    },
    showTable(res) {
      this.cols = []; //表头
      console.log(res);
      //var data_length = res.object.table.columnInfo.attCtr;
      // var table_data = this.getNewTableData(res);
      let table_title = res.object.table.columnInfo.names;
      this.totalRecords = res.object.table.totalRecords;
      this.missingRows = res.object.table.rowMissing;

      this.cols = table_title.map((i, e) => {
        return { label: i, prop: e + '' }
      })
      console.log(this.cols);
      this.rols = res.object.table.rows;
      //console.log(this.rols);
      this.rols_text = [];
      for (var i = 0; i < this.rols.length; i++) {
        var rols_ = {};
        //console.log(this.rols[i].cells);
        for (var j = 0; j < this.rols[0].cells.length; j++) {
          if (this.rols[i].cells[j] == null) {
            rols_[j] = "";
          } else {
            rols_[j] = this.rols[i].cells[j].val;
          }
        }
        this.rols_text.push(rols_);
      }
      this.tableShow = true;
    },
  },

  props: ["changeValue"],
  watch: {
    changeValue: function (value) {
      //console.log("changeValue");
      this.getTableInfo();
    },
  },
  created() {
    this.getSearchVal();
    this.getTableInfo();
    //this.select_value = this.$store.state.search_value.id

  },

  searchData() {
    this.getTableInfo();
    console.log(this.rols);
  },
};
</script>

<style>
/* .showTable .el-table__body-wrapper{
    height: 490px !important;
  } */
</style>

<style scoped>
.pagination {
  margin-top: 15px;
  text-align: left;
}

.el-selector-search {
  width: 18px;
}
</style>